/** Tabs on the shoot file (matches phone layout; ids kept for Playwright). */
export type ShootTab = 'money' | 'booking' | 'conversation' | 'details' | 'history';

/** @deprecated Prefer ShootTab. Kept so older call sites compile during migration. */
export type ClientTab = ShootTab | 'overview';

export function toShootTab(tab?: string | null): ShootTab {
  if (tab === 'booking' || tab === 'conversation' || tab === 'details' || tab === 'money' || tab === 'history') return tab;
  if (tab === 'overview') return 'money';
  return 'money';
}
